export { default } from './SkeletonMultipleTravelClasses';
